import { useAppContext } from "../../AppContext";
import message from "../../message";
import styles from "./index.module.css";
import Note from "../Note";

const Header = () => {
  const { intl } = useAppContext();
  return (
    <div>
      <h1 className={styles.title}>
        <img className={styles.logo} src="/static/images/logo.svg" alt="" />
        <span>{intl.formatMessage(message.Title)}</span>
      </h1>
      <Note></Note>
      <h2 className={`${styles.description} auto-debit-content-wrapper`}>
        {intl.formatMessage(message.Description)}
      </h2>
    </div>
  );
};

export default Header;
